import { format } from 'date-fns';
import { TrackedLocation } from '@/api/apis/resources';
import { UserRole } from '@/api/apis/user';
import { roleNames } from '@/constants/user.constants';
import { CustomerRoleT, CustomerRole } from '@/api/apis/customer';
import { CaseUserGroup } from '@/api/apis/case';

const QUOTE_APPROVER_ROLE = CustomerRole.TxCenterQuoteApprover;

export const GROUP_TO_ROLE: Partial<Record<CaseUserGroup, CustomerRoleT>> = {
  [CaseUserGroup.CustomerCoordinators]: CustomerRole.TxCenterCoordinator,
  [CaseUserGroup.CustomerReceivingSurgeons]: CustomerRole.ReceivingSurgeon,
  [CaseUserGroup.CustomerAdministrators]: CustomerRole.TxCenterAdministrator,
  [CaseUserGroup.CustomerTransplantSupporters]: CustomerRole.TxCenterTransplantSupport,
};

export const getRoleByGroup = (roles: UserRole[], group: CaseUserGroup): UserRole[] => {
  const roleToShow = GROUP_TO_ROLE[group];
  if (!roleToShow) return [];

  const result: UserRole[] = [];

  if (roles.includes(roleToShow as UserRole)) {
    result.push(roleToShow as UserRole);
  }

  if (roles.includes(QUOTE_APPROVER_ROLE as UserRole)) {
    result.push(QUOTE_APPROVER_ROLE as UserRole);
  }

  return result;
};

export const getFullName = (firstName?: string | null, lastName?: string | null) => {
  return `${firstName ?? ''} ${lastName ?? ''}`.trim();
};

export const getContactFullName = (firstName?: string | null, lastName?: string | null): string => {
  if (!firstName && !lastName) return 'Unnamed Contact';
  return `${firstName ?? ''} ${lastName ?? ''}`.trim();
};

export const getRoleNames = (roles?: UserRole[]) => {
  return roles?.map((r) => roleNames[r] ?? '').filter(Boolean) || [];
};

export const getRolesFormatted = (roles?: UserRole[]) => {
  return getRoleNames(roles)?.join(', ');
};

export const getRolesFiltered = (roles: UserRole[], rolesToShow: UserRole[]) => {
  const rolesFiltered = roles.filter((r) => rolesToShow.includes(r));
  return getRolesFormatted(rolesFiltered);
};

export const getLastTrackedTime = (location?: TrackedLocation) => {
  if (!location?.trackedTime) return '';
  return `Last tracked ${format(location.trackedTime, 'MM/dd/yyyy HH:mm zzz')}`;
};

export const getLastTrackedLocation = (location?: TrackedLocation) => {
  return location?.address || 'Location not available';
};

export enum CS_CERTIFICATE_TYPE {
  SHADOW = 'SHADOW',
  PROCTOR = 'PROCTOR',
}

export const CS_PROCTOR_SHADOW_TITLE: Record<CS_CERTIFICATE_TYPE, string> = {
  [CS_CERTIFICATE_TYPE.PROCTOR]: 'PTR',
  [CS_CERTIFICATE_TYPE.SHADOW]: 'SDW',
};
